// extracted by mini-css-extract-plugin
module.exports = {"iconYellow":"styles_iconYellow__J_tE9","sunHours":"styles_sunHours__UuCGA"};